import React, { Component } from "react";
import { Table, Tag, Button } from "antd";
import { RiFileCopyLine, RiTruckLine, RiFileTextLine } from "react-icons/ri";
import FulfilledShipmentDetails from "./FulfilledShipmentDetails";
import METHODS from "../../../constants/shipping/MethodTypesNew";
import { ShipmentTableHelpers } from "./ShipmentTableHelpers";

class FulfilledShipmentsTable extends Component {
    getRowClassName = (record) => {
        return ShipmentTableHelpers.getRowClassName(record);
    };

    calculateTimeSinceOrder(orderedAt) {
        if (!orderedAt) return null;

        const now = Math.floor(Date.now() / 1000);
        const orderTime = orderedAt;
        const diffSeconds = now - orderTime;
        const diffHours = diffSeconds / 3600;
        const diffDays = diffHours / 24;

        let text, color;

        if (diffHours < 24) {
            const hours = Math.floor(diffHours);
            text = `< ${hours === 0 ? 1 : hours + 1}h`;
            color = 'green';
        } else if (diffDays < 2) {
            text = '< 1 day';
            color = 'blue';
        } else if (diffDays < 3) {
            text = '< 2 days';
            color = 'orange';
        } else if (diffDays < 4) {
            text = '< 3 days';
            color = 'volcano';
        } else {
            const days = Math.floor(diffDays);
            text = `${days}d overdue`;
            color = 'red';
        }

        return (
            <Tag color={color} style={{ fontSize: '11px', fontWeight: 'bold' }}>
                {text}
            </Tag>
        );
    }

    render() {
        const { shipments, expandedRowKeys, onExpand } = this.props;

        const columns = [
            {
                title: 'Carrier',
                dataIndex: 'carrier',
                key: 'carrier',
                width: '10%',
                render: (text, record) => ShipmentTableHelpers.renderCarrierColumn(text, record)
            },
            {
                title: 'Store',
                dataIndex: 'brand',
                key: 'brand',
                width: '12%',
                render: (text, record) => ShipmentTableHelpers.renderStoreColumn(text, record)
            },
            {
                title: 'Shipment Details',
                dataIndex: 'shipmentId',
                key: 'shipmentDetails',
                width: '25%',
                render: (text, record) => {
                    const shipmentInfo = ShipmentTableHelpers.buildShipmentInformation(record);
                    const isUrgent = record.method === METHODS.CLICKCOLLECT || record.method === METHODS.SAME_DAY;
                    const shortShipmentId = text.substring(0, 13);

                    return (
                        <div>
                            <div 
                                style={{ 
                                    fontWeight: '700', 
                                    fontSize: '16px',
                                    color: isUrgent ? '#ff4d4f' : 'inherit'
                                }}
                            >
                                {shipmentInfo.carrierTitle}
                            </div>
                            <div style={{ 
                                fontWeight: '700', 
                                fontSize: '14px', 
                                textTransform: 'uppercase', 
                                color: '#666',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}>
                                <span style={{ userSelect: 'none' }}>SHIPMENT: </span>
                                <span style={{ userSelect: 'text' }}>{shortShipmentId}</span>
                                <button 
                                    type="button" 
                                    style={{ 
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '2px',
                                        height: '18px',
                                        width: '18px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={(e) => {
                                        navigator.clipboard.writeText(shortShipmentId);
                                        e.stopPropagation();
                                    }}
                                    title="Copy shipment ID"
                                >
                                    <RiFileCopyLine size={12} />
                                </button>
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Customer',
                dataIndex: 'customerName',
                key: 'customerName',
                width: '18%',
                render: (text) => text || 'N/A'
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                width: '12%',
                render: (text, record) => {
                    const shipmentInfo = ShipmentTableHelpers.buildShipmentInformation(record);
                    return shipmentInfo.status;
                }
            },
            {
                title: 'Actions',
                key: 'actions',
                width: '18%',
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button
                                type="default"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (record.localLabelUrl) {
                                        window.open(record.localLabelUrl, '_blank');
                                    }
                                }}
                                disabled={!record.localLabelUrl}
                            >
                                <RiTruckLine size={14} style={{ marginRight: '4px' }} />
                                Label
                            </Button>
                            <Button
                                type="default"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (record.pickslipUrl) {
                                        window.open(record.pickslipUrl, '_blank');
                                    }
                                }}
                                disabled={!record.pickslipUrl}
                            >
                                <RiFileTextLine size={14} style={{ marginRight: '4px' }} />
                                Pickslip
                            </Button>
                        </div>
                    );
                }
            }
        ];

        const expandedRowRender = (record) => {
            return <FulfilledShipmentDetails shipment={record} />;
        };

        return (
            <Table
                columns={columns}
                dataSource={shipments}
                rowKey="shipmentId"
                expandedRowRender={expandedRowRender}
                onExpand={onExpand}
                expandedRowKeys={expandedRowKeys}
                expandRowByClick={true}
                rowClassName={this.getRowClassName}
                locale={{ emptyText: this.props.emptyMessage }}
                pagination={{
                    pageSize: 100,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} fulfilled shipments`
                }}
                scroll={{ x: 1200 }}
            />
        );
    }
}

export default FulfilledShipmentsTable;